import EntityBase from '@/data/EntityBase';

export default class HourStatsOpenShiftsState extends EntityBase({
  updating: 0,
}) {}
